import RolesMgmtTable from "./views/RolesMgmtTable";
const RolesMgmt = () => {
  return (
    <div>
      <RolesMgmtTable />
    </div>
  );
};

export default RolesMgmt;
